<template>
  <div class="admin-page">
    <br><br>
    <transition name="toast">
      <toast v-if="toast" :msg="msg" />
    </transition>
    <ul class="menu-bar">
      <li
        class="menu-icon"
        @click="toggleAdmin"
      >
        <PlusIcon style="width: 25px;" />
        <p>New</p>
      </li>
      <li
        class="menu-icon"
        @click="toggleRecords"
      >
        <ViewListIcon style="width: 25px;" />
        <p>School Records</p>
      </li>
      <li
        class="menu-icon"
        @click="toggleMakeAnnouncement"
      >
        <DocumentAddIcon style="width: 25px;" />
        <p>Announcements</p>
      </li>
      <li
        class="menu-icon"
        @click="toggleNewBulletin"
      >
        <DocumentAddIcon style="width: 25px;" />
        <p>News Bulletin</p>
      </li>
      <li
        class="menu-icon"
        @click="toggleMessages"
      >
        <DocumentAddIcon style="width: 25px;" />
        <p>School Messages</p>
      </li>
    </ul>
    <br>
    <div v-if="showMakeAdmin">
      <CreateCredential @newCredentialCreated="triggerToast" />
    </div>
    <div v-if="showRecords">
      <Learners @toasts="deletedToast" />
      <Teachers @newCredentialCreated="triggerToast" />
      <Admins @newCredentialCreated="triggerToast" />
    </div>
    <div v-if="showMakeAnnouncement">
      <add-announcement
      @newClassAnnouncementCreated="toggleMakeAnnouncement"
      :classTeacher="currentUser"
      />
    </div>
    <div v-if="showNewsBulletin"
    >
      <bulletin-upload
        :uploader="currentUser.state"
        @fileuploaded="toggleMakeAnnouncement" />
    </div>
    <div v-if="showMessages"
    >
      <messages />
    </div>
    <div
      v-if="showWelcome"
      class="admin-card card"
    >
      <h3>Welcome Admin</h3>
      <p>Most of the school's administrative tasks can be carried out from here.</p>
      <p>These include adding teachers and learners to the school database, upgrading learners at the start of each new school year, sending out school wide notices on the virtual school noticeboard.</p>
    </div>
  </div>
</template>

<script>
import CreateCredential from '@/components/CreateCredential.vue'
import Teachers from '@/components/records/Teachers.vue'
import Learners from '@/components/records/Learners.vue'
import Admins from '@/components/records/Admins.vue'
import { DocumentAddIcon, ViewListIcon, PlusIcon } from '@heroicons/vue/outline'
import { ref } from '@vue/reactivity'
import Toast from '../components/Toast.vue'
import AddAnnouncement from '../components/AddAnnouncement.vue'
import { inject } from '@vue/runtime-core'
import BulletinUpload from '../components/BulletinUpload.vue'
import Messages from './announcements/Messages.vue'

export default {
  components: { CreateCredential, Learners, Teachers, DocumentAddIcon, ViewListIcon, PlusIcon, Admins, Toast, AddAnnouncement, BulletinUpload, Messages },
  setup () {
    const showMakeAdmin = ref(false)
    const showMakeAnnouncement = ref(false)
    const toast = ref(false)
    const msg = ref('Created')
    const currentUser = inject('currentUser')
    const showRecords = ref(false)
    const showWelcome = ref(true)
    const showNewsBulletin = ref(false)
    const showMessages = ref(false)

    const toggleAdmin = () => {
      showMakeAdmin.value = !showMakeAdmin.value
      showRecords.value = false
      showMakeAnnouncement.value = false
      showNewsBulletin.value = false
      showMessages.value = false
      showWelcome.value = !showMakeAdmin.value
    }

    const toggleRecords = () => {
      showRecords.value = !showRecords.value
      showMakeAdmin.value = false
      showMakeAnnouncement.value = false
      showNewsBulletin.value = false
      showMessages.value = false
      showWelcome.value = !showRecords.value
    }

    const toggleMakeAnnouncement = () => {
      showMakeAnnouncement.value = !showMakeAnnouncement.value
      showMakeAdmin.value = false
      showRecords.value = false
      showMessages.value = false
      showNewsBulletin.value = false
      showWelcome.value = !showMakeAnnouncement.value
    }

    const toggleNewBulletin = () => {
      showNewsBulletin.value = !showNewsBulletin.value
      showMakeAdmin.value = false
      showMessages.value = false
      showRecords.value = false
      showMakeAnnouncement.value = false
      showWelcome.value = !showNewsBulletin.value
    }

    const toggleMessages = () => {
      showMessages.value = !showMessages.value
      showNewsBulletin.value = false
      showMakeAdmin.value = false
      showRecords.value = false
      showMakeAnnouncement.value = false
      showWelcome.value = !showMessages.value
    }

    const triggerToast = () => {
      toast.value = true
      setTimeout(() => {
        toast.value = false
      }, 3000)
    }

    const deletedToast = () => {
      msg.value = 'Deleted'
      showRecords.value = false
      toast.value = true
      setTimeout(() => {
        toast.value = false
      }, 3000)
    }

    return { toggleAdmin, showMakeAdmin, toast, triggerToast, toggleRecords, showRecords, msg, deletedToast, toggleMakeAnnouncement, showMakeAnnouncement, currentUser, showWelcome, showNewsBulletin, toggleNewBulletin, showMessages, toggleMessages }
  }
}
</script>

<style>
.menu-bar {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  user-select: none;

  margin: 0.1em 0;
  padding: 0.4em;
  border-radius: 0.25em;
  height: 1.5em;
/* background: hotpink; */
  color: white;
  list-style-type: none;
}
.menu-bar .menu-icon {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  display: flex;
  border: orangered;
  position: relative;
}
.menu-bar .menu-icon p {
  padding: 5px 0 0 0;
}
.menu-bar .menu-icon a {
  display:-webkit-box;
  display:-moz-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  text-decoration: none;
  color: inherit;
  display: flex;
}
.admin-page {
  height: 100vh;
  max-width: 90vw;
  margin: auto;
}
.admin-card {
  color: white;
  max-width: 600px;
  margin: 0 auto;
  padding: 0.4em;
  border-radius: 0.25em;
  background: #bbb;
}
.admin-page .admin-card p {
  padding: 20px;
  margin: auto;
  font-size: 1.2em;
}
  /* enter transitions */
  .toast-enter-active {
    animation: wobble 0.5s ease;
  }
  /* leave transitions */
  .toast-leave-to {
    opacity: 0;
    transform: translateY(-60px);
  }
  .toast-leave-active {
    transition: all 0.3s ease;
  }

  @keyframes wobble {
    0% { transform: translateY(-100px); opacity: 0 }
    50% { transform: translateY(0px); opacity: 1 }
    60% { transform: translateX(8px); opacity: 1 }
    70% { transform: translateX(-8px); opacity: 1 }
    80% { transform: translateX(4px); opacity: 1 }
    90% { transform: translateX(-4px); opacity: 1 }
    100% { transform: translateX(0px); opacity: 1 }
  }
</style>
